export default {
  siteRoot: '',
  basePath: '',
  prefetchRate: 5,
  inlineCss: false,
  outputFileRate: 100,
  extractCssChunks: false,
  entry: './root/src/index.js',
  paths: {
    ROOT: './root/',
    SRC: './root/src',
    PUBLIC: './root/public',
    PACKAGE: './root/package.json',
    DIST: './root/tmp/dev-server',
    ASSETS: './root/tmp/dev-server',
    STATIC_DATA: './root/tmp/dev-server/staticData',
    HTML_TEMPLATE: './root/tmp/dev-server/index.html',
    LOCAL_NODE_MODULES: './dirname/../../node_modules',
    NODE_MODULES: './root/node_modules',
  },
}
